import { useEffect, useRef, useState } from "react";
import { FortuneWheelSectionItem } from "components/pages/Profile/FortuneWheelPage/type/FortuneWheel";
import { gapPxToDegrees } from "../../utils/geometry";
import Sector from "./components/Sector";
import "./styles.sass";

type Props = {
  sections: FortuneWheelSectionItem[];
  colors?: string[]; // Цвета секторов (чередуются)
  cornerRadius?: number; // Радиус скругления внешнего края сектора
  gapWidth?: number; // Ширина gap между секторами (px)
  fallbackDiameter?: number; // Фолбэк-диаметр, пока контейнер не измерен
  textOffsetFromEdge?: number; // Отступ текста от внешней дуги (px)
};

export const WheelDisk = ({
  sections,
  colors = ["#F529A8", "#1E40FF"],
  cornerRadius = 10,
  gapWidth = 2,
  fallbackDiameter = 300,
  textOffsetFromEdge = 20,
}: Props) => {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [size, setSize] = useState<number>(fallbackDiameter);

  useEffect(() => {
    const el = svgRef.current;
    if (!el) {
      return;
    }

    const measure = () => {
      const rect = el.getBoundingClientRect();
      const s = Math.max(0, Math.min(rect.width, rect.height || rect.width));
      if (s > 0) {
        setSize(s);
      }
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const segments = sections.length;
  const outerRadius = size / 2;
  const sectorAngle = 360 / segments;

  // переводим «пиксельный» gap в градусы текущего масштаба
  const gapAngle = gapPxToDegrees(outerRadius, gapWidth);
  const wedgeAngle = sectorAngle - gapAngle;
  const halfWedge = wedgeAngle / 2;

  const viewBox = `${-outerRadius} ${-outerRadius} ${size} ${size}`;

  return (
    <svg ref={svgRef} className="WheelDisk__svg" viewBox={viewBox}>
      {sections.map((section, i) => (
        <Sector
          key={section.id}
          section={section}
          outerRadius={outerRadius}
          startAngle={-halfWedge + i * sectorAngle}
          endAngle={halfWedge + i * sectorAngle}
          cornerRadius={cornerRadius}
          fill={colors[i % colors.length]}
          textOffsetFromEdge={textOffsetFromEdge}
        />
      ))}
    </svg>
  );
};
